import React from "react";
import Loader from "@components/Loader";
import { useCustomerFeedbackQuery } from "@queries/customers/customer_feedback";
import "@styles/opencart-admin.css";

export default function CustomerFeedbackPage() {
  const [filters, setFilters] = React.useState({
    customer_id: ""
  });
  const [page, setPage] = React.useState(1);
  const pageSize = 50;

  const { data, isLoading, isFetching, isError, error } =
    useCustomerFeedbackQuery(
      {
        customer_id: filters.customer_id || undefined
      },
      page,
      pageSize
    );

  const rows = data?.data || [];
  const total = data?.meta?.total ?? rows.length;
  const pages = Math.max(1, Math.ceil(total / pageSize));

  function handleFilterChange(field, value) {
    setFilters((prev) => ({ ...prev, [field]: value }));
    setPage(1);
  }

  function formatDate(dt) {
    if (!dt) return "";
    // expect "YYYY-MM-DD..." string
    if (typeof dt === "string") {
      return dt.substring(0, 10);
    }
    try {
      return new Date(dt).toISOString().substring(0, 10);
    } catch {
      return "";
    }
  }

  return (
    <div className="oc-content">
      {(isLoading || isFetching) && <Loader />}

      <div className="oc-header">
        <h1>App Feedback</h1>
        <nav className="oc-bc">
          <span>Home</span>
          <span className="sep">›</span>
          <span>App Feedback</span>
        </nav>
      </div>

      <div className="oc-card">
        <div className="oc-toolbar" style={{ marginBottom: 12 }}>
          <div>
            <strong>App Feedback</strong>
          </div>
        </div>

        {isError && (
          <div style={{ color: "#c00", marginBottom: 8 }}>
            Error: {error?.message || "Unknown error"}
          </div>
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 260px",
            gap: 16
          }}
        >
          {/* table */}
          <div>
            <table className="oc-table">
              <thead>
                <tr>
                  <th style={{ width: 110 }}>Customer ID</th>
                  <th style={{ width: 220 }}>Customer Name</th>
                  <th style={{ width: 160 }}>Phone Number</th>
                  <th>Feedback</th>
                  <th style={{ width: 120 }}>Date Added</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 && (
                  <tr>
                    <td colSpan={5} style={{ textAlign: "center", padding: 24 }}>
                      No feedback found
                    </td>
                  </tr>
                )}
                {rows.map((row) => {
                  const c = row.customer || {};
                  return (
                    <tr key={row.id}>
                      <td>
                        {/* Just styled text; you can replace with a real link later */}
                        <span className="oc-link">{row.customer_id}</span>
                      </td>
                      <td>{c.name}</td>
                      <td>{c.telephone || c.alt_mobile || ""}</td>
                      <td dir="auto">{row.feedback}</td>
                      <td>{formatDate(row.date_added)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* filter panel */}
          <div className="oc-card" style={{ margin: 0 }}>
            <div className="title">Filter</div>
            <div className="form-group">
              <label>Customer ID</label>
              <input
                className="oc-input"
                value={filters.customer_id}
                onChange={(e) =>
                  handleFilterChange("customer_id", e.target.value)
                }
                placeholder="e.g. 3159"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="oc-card"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 16
        }}
      >
        <div>
          Showing page <strong>{page}</strong> of <strong>{pages}</strong> (
          {total} total)
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button
            className="oc-btn ghost"
            disabled={page <= 1}
            onClick={() => setPage(1)}
          >
            « First
          </button>
          <button
            className="oc-btn ghost"
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            ‹ Prev
          </button>
          <button
            className="oc-btn ghost"
            disabled={page >= pages}
            onClick={() => setPage((p) => p + 1)}
          >
            Next ›
          </button>
          <button
            className="oc-btn ghost"
            disabled={page >= pages}
            onClick={() => setPage(pages)}
          >
            Last »
          </button>
        </div>
      </div>
    </div>
  );
}

